import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import { MultiSelect } from 'primereact/multiselect';

const Send = () => {
  
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const [users, setUsers] = useState([]);

  const [formData, setFormData] = useState({
    title: '',
    title_ar: '',
    message: '',
    message_ar: '',
    recipient_type: 'all',
    recipient_ids: [],
  });

  useEffect(() => {
    getActiveUsers();
  }, []);

  const getActiveUsers = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `users-list`,
      });
      const data = response.data;
      if (data.status) {
        setUsers(data.data);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleMultiSelectChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      recipient_ids: e.value || [],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.title || !formData.message) {
      toast.error('Title and message are required');
      return;
    }

    if (formData.recipient_type === 'specific' && (!formData.recipient_ids || formData.recipient_ids.length === 0)) {
      toast.error('Please select at least one user');
      return;
    }

    setIsLoader(true);

    try {
      const response = await ApiService.request({
        method: 'POST',
        url: `custom-notifications/send`,
        data: formData,
      });

      if (response.data.status) {
        toast.success(response.data.message);
        navigate('/custom-notifications');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error('Form submission failed:', error);
      toast.error(error.response?.data?.message || 'Failed to send notification');
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              Send Custom Notification
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <Link to="/dashboard" className="text-muted text-hover-primary">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <Link to="/custom-notifications" className="text-muted text-hover-primary">Custom Notifications</Link>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">Send Notification</li>
            </ul>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body pt-0">
              <form onSubmit={handleSubmit} className="form fv-plugins-bootstrap5 fv-plugins-framework">
                <div className="row g-9 my-3">
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Title</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Enter Notification Title"
                      required
                      name="title"
                      value={formData.title}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="fs-6 fw-semibold mb-2">Title Arabic (Optional)</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Enter Notification Title Arabic"
                      name="title_ar"
                      value={formData.title_ar}
                      onChange={handleChange}
                    />
                  </div>
                  
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Message</label>
                    <textarea
                      name="message"
                      rows="4"
                      value={formData.message}
                      onChange={handleChange}
                      className="form-control form-control-solid"
                      placeholder="Enter Notification Message"
                      required
                    />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="fs-6 fw-semibold mb-2">Message Arabic (Optional)</label>
                    <textarea
                      name="message_ar"
                      rows="4"
                      value={formData.message_ar}
                      onChange={handleChange}
                      className="form-control form-control-solid"
                      placeholder="Enter Notification Message Arabic"
                    />
                  </div>

                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Recipient Type</label>
                    <select
                      name="recipient_type"
                      value={formData.recipient_type}
                      onChange={handleChange}
                      className="form-select form-control-solid"
                      required
                    >
                      <option value="all">All Users</option>
                      <option value="specific">Specific Users</option>
                    </select>
                  </div>

                  {formData.recipient_type === 'specific' && (
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2">Select Users</label>
                      <MultiSelect
                        value={formData.recipient_ids}
                        onChange={handleMultiSelectChange}
                        options={users}
                        optionLabel="name"
                        optionValue="_id"
                        filter
                        placeholder="Select Users"
                        maxSelectedLabels={3}
                        className="w-100"
                      />
                      {formData.recipient_ids.length > 0 && (
                        <div className="text-muted fs-7 mt-2">
                          {formData.recipient_ids.length} user(s) selected
                        </div>
                      )}
                    </div>
                  )}

                  {formData.recipient_type === 'all' && (
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <div className="alert alert-info d-flex align-items-center p-5">
                        <i className="bi bi-info-circle-fill fs-2x text-primary me-4"></i>
                        <div className="d-flex flex-column">
                          <h4 className="mb-1">All Users</h4>
                          <span>This notification will be sent to all active users who have device tokens registered.</span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="row g-9 my-3">
                  <div className="text-center">
                    <Link to="/custom-notifications" className="btn btn-light me-3">
                      Cancel
                    </Link>
                    <button type="submit" className="btn btn-base" disabled={isLoader}>
                      <span className="indicator-label">
                        {isLoader ? <Loader size="20" color="black" text="Sending" /> : (
                          <>
                            <i className="bi bi-send-fill me-2"></i>Send Notification
                          </>
                        )}
                      </span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Send;

